import { Injectable } from "@angular/core";
import { initialState } from "../state/notifications.state";
import { BehaviorSubject } from "rxjs";
import {
  NotificationState,
  Notifications,
} from "../interfaces/notification-state.interface";
import { Utils } from "@serasa/shared/utils/utils";
import { environment } from "@environments";
import { HttpClient } from "@angular/common/http";
import { NotificationsResponse } from "../interfaces/notifications.interface";
import { NotificationsEventTypes } from "../interfaces/notifications-event-types.enum";

@Injectable({
  providedIn: "root",
})
export class NotificationsService {

  public notificationState = initialState;
  public manager = new BehaviorSubject<NotificationState>(this.notificationState);

  private _source = '';

  constructor(
    private _http: HttpClient
  ) { 
    this._source = Utils.getBaseUrl(environment.env);
  }

  public getNotifications(): BehaviorSubject<NotificationState> {
    return this.manager;
  }

  public getMyUserNotifications() {
    const headers = Utils.generateDefaultHeader();
    const url = `${this._source}/product-menu/security/v1/my-user-notifications`;

    return this._http.get<NotificationsResponse>(url, { headers });
  }

  public setNotifications(notifications: Notifications[]): void {
    this.notificationState.notifications =
      this.notificationState.notifications.concat(notifications);
    this.manager.next(this.notificationState);
  }

  public clearNotifications(): void {
    this.manager.next(initialState);
  }

  public setEventDismissed(userNotificationId: string) {
    return this.setEvent(userNotificationId, NotificationsEventTypes.DISMISS);
  }

  public setEventLoad(userNotificationId: string) {
    return this.setEvent(userNotificationId, NotificationsEventTypes.LOAD);
  }

  public setEvent(userNotificationId: string, eventType: NotificationsEventTypes) {
    const headers = Utils.generateDefaultHeader();
    const url = `${this._source}/digital/notification/v1/my-user-notifications/${userNotificationId}/add-event`;
    return this._http.post<NotificationsResponse>(url, { eventType }, { headers });
  }

}
